import commonApi from "../../api/common/commonApi";

const state = {};

const mutations = {};

const actions = {
  getAllHomeBannerImageList({ state }, { params, callback }) {
    console.log(state);
    commonApi.getAllHomeBannerImageListApi({ params, callback }, res => {
      callback(res);
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/common.js